import Block from './Block'
import Title from './Title'
import tools from './tools'

export default {
  Block,
  Title,
  tools
}
